export default __webpack_public_path__ + "static/media/keneth.5a6901da.png";